var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPensil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#919EAB",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5002 21.1255L21.6635 14.9621C20.6266 14.5292 19.6848 13.8967 18.8918 13.1005C18.0953 12.3073 17.4625 11.3653 17.0293 10.328L10.866 16.4913C10.3852 16.9721 10.1443 17.213 9.93768 17.478C9.6936 17.7907 9.48431 18.1291 9.31351 18.4871C9.16935 18.7905 9.06185 19.1138 8.84685 19.7588L7.71185 23.1613C7.65961 23.3171 7.65186 23.4844 7.68947 23.6443C7.72707 23.8043 7.80855 23.9506 7.92474 24.0667C8.04093 24.1829 8.18722 24.2644 8.34717 24.302C8.50712 24.3396 8.67439 24.3319 8.83018 24.2796L12.2327 23.1446C12.8785 22.9296 13.201 22.8221 13.5043 22.678C13.8627 22.5071 14.201 22.298 14.5135 22.0538C14.7785 21.8471 15.0193 21.6063 15.5002 21.1255ZM23.3735 13.2521C23.988 12.6376 24.3333 11.8041 24.3333 10.9351C24.3333 10.066 23.988 9.2325 23.3735 8.61797C22.759 8.00344 21.9255 7.6582 21.0564 7.6582C20.1874 7.6582 19.3539 8.00344 18.7393 8.61797L18.0002 9.35714L18.0318 9.44964C18.3961 10.4919 18.9922 11.4379 19.7752 12.2163C20.5769 13.0227 21.556 13.6306 22.6343 13.9913L23.3735 13.2521Z",
    fill: "#637381"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPensil);
export default __webpack_public_path__ + "static/media/pensil.8bd0b4125cb848b52776ed92d7a6227b.svg";
export { ForwardRef as ReactComponent };